import React from 'react';
import { Button } from "@/components/ui/button";
import { Navigation } from "./Navigation";
import { Link } from "gatsby";
import logo from "@/assets/logo.svg";
import { BOOKING_URL, LINK_ATTRIBUTES } from "@/lib/config";
import { Phone } from "lucide-react";
import TelLink from "./TelLink";

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border transition-gentle">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Left Section - Hamburger Menu & Logo */}
          <div className="flex items-center space-x-6">
            <Navigation />
            <Link to="/" className="flex items-center transition-gentle hover:scale-105">
              <img
                src={logo}
                alt="Y3 Smiles Dental Logo"
                width={160}
                height={48}
                className="h-12 w-auto transition-gentle hover:drop-shadow-lg"
              />
            </Link>
          </div>

          {/* Right Section - Navigation Links & CTA */}
          <div className="flex items-center justify-end space-x-6">
            {/* Desktop Navigation Links — ordered to influence Google sitelink hierarchy */}
            <nav className="hidden lg:flex items-center space-x-5">
              <Link
                to="/about/"
                className="text-neutral-700 hover:text-primary transition-gentle font-medium hover:scale-105 text-lg"
              >
                About
              </Link>
              <Link
                to="/about/our-team/"
                className="text-neutral-700 hover:text-primary transition-gentle font-medium hover:scale-105 text-lg"
              >
                Team
              </Link>
              <Link
                to="/treatments/"
                className="text-neutral-700 hover:text-primary transition-gentle font-medium hover:scale-105 text-lg"
              >
                Treatments
              </Link>
              <Link
                to="/news-and-articles/"
                className="text-neutral-700 hover:text-primary transition-gentle font-medium hover:scale-105 text-lg"
              >
                News & Articles
              </Link>
              <Link
                to="/patient-resources/pricing/"
                className="text-neutral-700 hover:text-primary transition-gentle font-medium hover:scale-105 text-lg"
              >
                Cost
              </Link>
            </nav>

            {/* Phone & CTA Buttons */}
            <div className="flex items-center space-x-3">
              {/* Phone number - full on desktop, icon on mobile */}
              <TelLink
                clickSource="header_desktop"
                className="hidden md:block text-neutral-800 hover:text-primary transition-gentle font-medium hover:scale-105 text-lg"
              >
                03 9022 4442
              </TelLink>
              <Button variant="ghost" size="icon" asChild className="md:hidden text-neutral-800 hover:text-primary">
                <TelLink
                  clickSource="header_mobile"
                  aria-label="Call us"
                >
                  <Phone className="h-5 w-5" />
                </TelLink>
              </Button>
              {/* Booking button - shortened text */}
              <Button variant="booking" size="lg" asChild>
                <a href={BOOKING_URL} {...LINK_ATTRIBUTES}>
                  BOOK
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;